import _asyncToGenerator from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { rankItem } from '@tanstack/match-sorter-utils';
import * as R from 'ramda';
import { useCallback, useEffect, useRef } from 'react';
import { TableColor } from 'src/types/crudTable';
import { parseErrorMessage } from 'src/utils/error';
export var getNestColumns = function getNestColumns(_ref) {
  var line = _ref.line,
      t = _ref.t,
      renderCell = _ref.renderCell;
  return line.map(function (item) {
    var _item$columns;

    return _objectSpread(_objectSpread({}, item), {}, {
      cell: renderCell,
      header: !!(item !== null && item !== void 0 && item.header) ? t(item.header, item.text || '') : '-',
      columns: item !== null && item !== void 0 && item.columns ? item === null || item === void 0 ? void 0 : (_item$columns = item.columns) === null || _item$columns === void 0 ? void 0 : _item$columns.map(function (column) {
        return _objectSpread(_objectSpread({}, column), {}, {
          header: !!(column !== null && column !== void 0 && column.header) ? t(column === null || column === void 0 ? void 0 : column.header, (column === null || column === void 0 ? void 0 : column.text) || '') : '-',
          cell: renderCell
        });
      }) : []
    });
  });
};
export var fuzzyFilter = function fuzzyFilter(row, columnId, value, addMeta) {
  // Rank the item
  var itemRank = rankItem(row.getValue(columnId), value); // Store the itemRank info

  addMeta({
    itemRank: itemRank
  }); // Return if the item should be filtered in/out

  return itemRank.passed;
};
/**
 * Skip page index reset until after next rerender, useful for preventing setting page index to 0 after a data change
 * @see {@link https://codesandbox.io/p/devbox/github/tanstack/table/tree/main/examples/react/editable-data?embed=1&file=%2Fsrc%2Fmain.tsx&theme=dark example}
 */

export function useSkipper() {
  var shouldSkipRef = useRef(true);
  var shouldSkip = shouldSkipRef.current; // Wrap a function with this to skip a pagination reset temporarily

  var skip = useCallback(function () {
    shouldSkipRef.current = false;
  }, []);
  useEffect(function () {
    shouldSkipRef.current = true;
  });
  return [shouldSkip, skip];
}
export var getColumnProps = function getColumnProps(_ref2) {
  var isDisabled = _ref2.isDisabled;
  return {
    color: isDisabled ? '#A2A2A2' : 'blackAlpha.300',
    bg: isDisabled && '#E7E7E7'
  };
};
/**
 * 左/右凍結欄位，給予欄位 index，可接受負數
 */

var getColumnId = function getColumnId(column) {
  var _ref3, _column$id;

  return (_ref3 = (_column$id = column.id) !== null && _column$id !== void 0 ? _column$id : column.accessorKey) !== null && _ref3 !== void 0 ? _ref3 : column.header;
};

export var getColumnPinning = function getColumnPinning(columns, stickyColumns) {
  var _stickyColumns$right, _stickyColumns$left;

  var formatStickyColumns = R.pipe(R.map(function (i) {
    return i < 0 ? i + columns.length : i;
  }), R.uniq, R.sort(function (a, b) {
    return a - b;
  }), R.map(function (i) {
    return getColumnId(columns[i]);
  }));
  var right = (_stickyColumns$right = stickyColumns === null || stickyColumns === void 0 ? void 0 : stickyColumns.right) !== null && _stickyColumns$right !== void 0 ? _stickyColumns$right : [];
  var left = (_stickyColumns$left = stickyColumns === null || stickyColumns === void 0 ? void 0 : stickyColumns.left) !== null && _stickyColumns$left !== void 0 ? _stickyColumns$left : [];
  return {
    right: formatStickyColumns(right),
    left: ['select'].concat(formatStickyColumns(left))
  };
};

var withPostfixImportant = function withPostfixImportant(value) {
  return "".concat(value, " !important");
};

var getCellBackgroundColor = function getCellBackgroundColor(isHeader, isDisabled, isCellChanged, isRowSelected, isPreview, isPinned) {
  if (isHeader) {
    return undefined;
  } // add `!important` to row hovered background color


  if (isDisabled) {
    return withPostfixImportant(TableColor.bg_disabled);
  }

  if (isCellChanged) {
    return withPostfixImportant(isPreview ? TableColor.bg_cell_changed_preview : TableColor.bg_cell_changed);
  }

  if (isRowSelected) {
    return withPostfixImportant(TableColor.bg_row_selected);
  }

  if (isPinned) {
    return TableColor.bg_default;
  }

  return undefined;
};

export var getColumnStyleAndProps = function getColumnStyleAndProps(column) {
  var _columnDef$align;

  var isHeader = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isDisabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isCellChanged = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var isRowSelected = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var isPreview = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var isPinned = column.getIsPinned();
  var isLastLeftPinnedColumn = isPinned === 'left' && column.getIsLastColumn('left');
  var isFirstRightPinnedColumn = isPinned === 'right' && column.getIsFirstColumn('right');
  var columnDef = column.columnDef;
  var color = isDisabled ? TableColor.text_disabled : TableColor.text_default;
  var backgroundColor = getCellBackgroundColor(isHeader, isDisabled, isCellChanged, isRowSelected, isPreview, Boolean(isPinned));
  var style = {
    maxWidth: columnDef === null || columnDef === void 0 ? void 0 : columnDef.maxWidth,
    minWidth: columnDef === null || columnDef === void 0 ? void 0 : columnDef.minWidth,
    textAlign: (_columnDef$align = columnDef.align) !== null && _columnDef$align !== void 0 ? _columnDef$align : 'left',
    boxShadow: isLastLeftPinnedColumn ? '-4px 0 4px -4px gray inset' : isFirstRightPinnedColumn ? '4px 0 4px -4px gray inset' : undefined,
    zIndex: isPinned ? 1 : 0,
    borderBottomWidth: isHeader ? undefined : '1px',
    left: isPinned === 'left' ? "".concat(column.getStart('left'), "px") : undefined,
    right: isPinned === 'right' ? "".concat(column.getAfter('right'), "px") : undefined,
    position: isPinned ? 'sticky' : 'relative',
    // configure `columnDef.size` to enable `column.getSize()` calculation
    width: column.getSize()
  };
  return {
    style: style,
    color: color,
    backgroundColor: backgroundColor
  };
};
export function generateStatusMessage(records, result, t) {
  var total = records.length;
  var successCount = result.successCount,
      failureCount = result.failureCount,
      errors = result.errors,
      isFullySuccessful = result.isFullySuccessful,
      isFullyFailed = result.isFullyFailed;
  var failures = errors.map(function (_ref4) {
    var index = _ref4.index,
        error = _ref4.error;
    return {
      item: records[index],
      error: error
    };
  });
  var description = summarizeFailures(failures, t);

  if (isFullySuccessful) {
    return {
      status: 'success',
      title: t('common:normal.successfullyUpdated', '更新成功')
    };
  } else if (isFullyFailed) {
    return {
      status: 'error',
      title: t('common:saveFailed', '儲存失敗'),
      description: description
    };
  } else {
    return {
      status: 'warning',
      title: t('common:table.updateRecordsPartially', "\u7E3D\u5171 ".concat(total, " \u7B46\u8CC7\u6599\uFF0C").concat(successCount, " \u7B46\u6210\u529F\uFF0C").concat(failureCount, " \u7B46\u5931\u6557"), {
        total: total,
        successCount: successCount,
        failureCount: failureCount
      }),
      description: description
    };
  }
}

function summarizeFailures(failures, t) {
  if (failures.length === 0) return null;
  return failures.map(function (f) {
    var name = f.item._name || f.item.id;
    var error_message = parseErrorMessage(f.error, t);
    return t('common:error.bulkUpdateErrorMessage', "\u9805\u76EE\"".concat(name, "\"\u8ACB\u6C42\u5931\u6557 - ").concat(error_message), {
      name: name,
      error_message: error_message
    });
  }).join('\n');
}

export function handleBulkUpdates(_x) {
  return _handleBulkUpdates.apply(this, arguments);
}
/**
 * getCellValue can be used in `columnDef.accessorFn` or other places to get cell value by columnId
 * @param rowData
 * @param columnId e.g. name, profile.name, meta.age etc.
 * @returns
 */

function _handleBulkUpdates() {
  _handleBulkUpdates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(promises) {
    var successCount, failureCount, errors, total, safePromises, results;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // Initialize counters
            successCount = 0;
            failureCount = 0;
            errors = [];
            total = promises.length; // Convert each promise to a version that never rejects

            safePromises = promises.map( /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(promise, index) {
                var result;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return promise;

                      case 3:
                        result = _context.sent;
                        successCount++;
                        return _context.abrupt("return", {
                          status: 'fulfilled',
                          value: result,
                          index: index
                        });

                      case 8:
                        _context.prev = 8;
                        _context.t0 = _context["catch"](0);
                        failureCount++;
                        errors.push({
                          index: index,
                          error: _context.t0
                        });
                        return _context.abrupt("return", {
                          status: 'rejected',
                          error: _context.t0,
                          index: index
                        });

                      case 13:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[0, 8]]);
              }));

              return function (_x2, _x3) {
                return _ref5.apply(this, arguments);
              };
            }()); // Wait for all promises to complete

            _context2.next = 7;
            return Promise.all(safePromises);

          case 7:
            results = _context2.sent;
            return _context2.abrupt("return", {
              results: results,
              successCount: successCount,
              failureCount: failureCount,
              errors: errors,
              isFullySuccessful: successCount === total,
              isPartiallySuccessful: successCount > 0 && failureCount > 0,
              isFullyFailed: failureCount === total
            });

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _handleBulkUpdates.apply(this, arguments);
}

export var getCellValue = function getCellValue(columnId, rowData) {
  return R.path(columnId.split('.'), rowData);
};
/**
 * getInitTableData will add `_original` to each row for tracking changes
 */

export var getInitTableData = function getInitTableData(data) {
  return data ? data.map(function (row) {
    return _objectSpread(_objectSpread({}, row), {}, {
      _original: row
    });
  }) : [];
};